var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',[_c('bread-crumb',{staticClass:"perfil-bread-crumb",attrs:{"classe":"conta","titulo":"Minha conta"}}),_c('div',{attrs:{"id":"MinhaConta"}},[(_vm.internalLoading)?_c('internal-loading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }